import { scoreTriggerCodec } from '@/services/api/resources/scoreTrigger';
import * as t from 'io-ts';
import { id, user, group } from '@/services/api';
import { IssuePriority } from '@/entities/issue';

const issueTemplateAssignee = user;
const issueTemplateApprovers = user;
const issueTemplateGroupAssignee = group;
const issueTemplateAssociateAssignee = t.type({
  id: t.number,
  email: t.string,
});

const priority = t.union([
  //remove Low here when we sure that it is no more in DB
  t.literal(IssuePriority.Low),
  t.literal(IssuePriority.Normal),
  t.literal(IssuePriority.High),
]);

export const dueInCodec = t.type({
  weeks: t.union([t.number, t.null]),
  days: t.union([t.number, t.null]),
  hours: t.union([t.number, t.null]),
  minutes: t.union([t.number, t.null]),
});

export const issueTemplateCodec = t.type({
  title: t.string,
  description: t.union([t.string, t.null]),
  priority,
  assignees: t.array(issueTemplateAssignee),
  assignedGroups: t.array(issueTemplateGroupAssignee),
  associateAssignees: t.array(issueTemplateAssociateAssignee),
  entityItemSpecificAssignments: t.boolean,
  dueIn: t.union([dueInCodec, t.null]),
  scoreTrigger: t.union([scoreTriggerCodec, t.null]),
  approvalsEnabled: t.boolean,
  approvalsEntitySpecificAssignments: t.boolean,
  approvers: t.array(issueTemplateApprovers),
});

export const issueFormCodec = t.type({
  title: t.string,
  description: t.union([t.string, t.null]),
  priority,
  assignees: t.array(t.number),
  assignedGroups: t.array(t.number),
  associateAssignees: t.array(t.string),
  entityItemSpecificAssignments: t.boolean,
  dueIn: t.union([dueInCodec, t.null]),
  scoreTrigger: t.union([scoreTriggerCodec, t.null]),
  approvalsEnabled: t.boolean,
  approvalsEntitySpecificAssignments: t.boolean,
  approvers: t.array(t.number),
});

export const issueTemplateRecordCodec = t.type({
  id,
  data: issueTemplateCodec,
});

export const issueTemplateListCodec = t.type({
  data: t.array(issueTemplateRecordCodec),
});
